/**
 * Loading Skeleton for Signup Page
 *
 * Matches SignupForm: name row, email, the two consent checkboxes, submit.
 */
export function SignupSkeleton() {
  return (
    <div className='absolute inset-0 flex items-center justify-center px-4'>
      <div className='w-full max-w-md space-y-6'>
        {/* Header Skeleton */}
        <div className='text-center space-y-2'>
          <div className='h-9 bg-muted/30 rounded-lg w-56 mx-auto animate-pulse' />
          <div className='h-5 bg-muted/20 rounded w-64 mx-auto animate-pulse' />
        </div>

        {/* Form Card Skeleton */}
        <div className='bg-white rounded-2xl shadow-lg border border-border/50 p-6 sm:p-8 space-y-6'>
          <div className='space-y-4'>
            {/* First / Last Name Skeleton */}
            <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
              <div className='space-y-1.5'>
                <div className='h-5 bg-muted/30 rounded w-20 animate-pulse' />
                <div className='h-10 bg-muted/20 rounded-lg w-full animate-pulse' />
              </div>
              <div className='space-y-1.5'>
                <div className='h-5 bg-muted/30 rounded w-20 animate-pulse' />
                <div className='h-10 bg-muted/20 rounded-lg w-full animate-pulse' />
              </div>
            </div>

            {/* Email Field Skeleton */}
            <div className='space-y-1.5'>
              <div className='h-5 bg-muted/30 rounded w-12 animate-pulse' />
              <div className='h-10 bg-muted/20 rounded-lg w-full animate-pulse' />
            </div>

            {/* Consent Checkbox Skeletons */}
            <div className='space-y-3 pt-1'>
              <div className='flex items-start gap-3'>
                <div className='size-4 bg-muted/30 rounded animate-pulse' />
                <div className='h-5 bg-muted/20 rounded w-56 animate-pulse' />
              </div>
              <div className='flex items-start gap-3'>
                <div className='size-4 bg-muted/30 rounded animate-pulse' />
                <div className='h-5 bg-muted/20 rounded w-64 animate-pulse' />
              </div>
            </div>

            {/* Submit Button Skeleton */}
            <div className='pt-2'>
              <div className='h-10 bg-gradient-primary from-navy/80 to-royal-blue/80 rounded-lg w-full animate-pulse' />
            </div>
          </div>

          {/* Sign In Link Skeleton */}
          <div className='text-center'>
            <div className='h-5 bg-muted/20 rounded w-48 mx-auto animate-pulse' />
          </div>
        </div>
      </div>
    </div>
  )
}
